import type { SchemaOf } from '../../helpers';
import { Joi, makeAllOptional } from '../../helpers';

export interface IConfig {
  // pictures below this height do not get taken and recorded
  minimumHeight: number;
  // ideal face height for snapshot before we send it to the cloud
  idealHeight: number;
  // height of the face after which we assume the person needs to be addressed
  attentionHeight: number;
  // maximum gaze tilt deviation (degrees)
  tiltDeviation: number;
  // sharpness threshold for attention thresholding
  sharpnessThreshold: number;
  // number of seconds between periodical snapshots, disabled if <= 0
  periodicalSnapshotSeconds: number;
  // time between attention trigger events on the recorder
  attentionThrottleSeconds: number;
  // organisation face refresh time for consoles
  organisationFaceRefreshTimeSeconds: number;
  farSnapshotTimeout: number;
  // how long to wait to collect the best possible face snapshot
  faceSnapshotBufferTime: number;
}

export const schemaMapDefault: SchemaOf<IConfig> = {
  minimumHeight: Joi.number().required(),
  idealHeight: Joi.number().required(),
  attentionHeight: Joi.number().required(),
  tiltDeviation: Joi.number().required(),
  sharpnessThreshold: Joi.number().required(),
  periodicalSnapshotSeconds: Joi.number().required(),
  attentionThrottleSeconds: Joi.number().required(),
  organisationFaceRefreshTimeSeconds: Joi.number().required(),
  farSnapshotTimeout: Joi.number().required(),
  faceSnapshotBufferTime: Joi.number().required(),
};

export const schemaMap = makeAllOptional<IConfig>(schemaMapDefault);

export const defaultConfig: IConfig = {
  attentionHeight: 0.25,
  idealHeight: 0.2,
  minimumHeight: 0.1,
  tiltDeviation: 10.0,
  sharpnessThreshold: 100,
  periodicalSnapshotSeconds: 1,
  attentionThrottleSeconds: 30 * 60, // 30 minutes
  organisationFaceRefreshTimeSeconds: 60, // every minute
  farSnapshotTimeout: 250, // ms
  faceSnapshotBufferTime: 4000, // ms
};
